import type { MappingParameterRepairKind } from './mappingProjectReadiness';
import {
  buildRepairStepIds,
  type MappingRepairProgressStepId,
} from './mappingRepairProgress';

const RepairStepOrder: MappingRepairProgressStepId[] = [
  'connector',
  'quickFillClassification',
  'bolt',
  'additional',
  'processProject',
  'mapping',
  'quickFill',
  'verify',
];

export interface MappingRepairLogPlanInput {
  repairKinds: MappingParameterRepairKind[];
  repairParameterCounts: Record<MappingParameterRepairKind, number>;
  repairableCount: number;
}

export interface MappingRepairLogPlanStep {
  stepId: MappingRepairProgressStepId;
  disposition: 'planned' | 'skipped';
  affectedCount: number;
}

export function buildMappingRepairLogPlan(
  input: MappingRepairLogPlanInput
): MappingRepairLogPlanStep[] {
  const plannedStepIds = new Set(buildRepairStepIds(input.repairKinds));
  const familyRepairCount =
    input.repairParameterCounts.bolt + input.repairParameterCounts.additional;
  const affectedCountFor = (stepId: MappingRepairProgressStepId): number => {
    if (stepId === 'quickFill') {
      return familyRepairCount;
    }

    if (stepId === 'quickFillClassification') {
      // The primer owns no setup parameters of its own.
      return 0;
    }

    if (stepId === 'verify') {
      return input.repairableCount;
    }

    return input.repairParameterCounts[stepId as MappingParameterRepairKind] ?? 0;
  };

  return RepairStepOrder.map((stepId) => ({
    stepId,
    disposition: plannedStepIds.has(stepId) ? 'planned' : 'skipped',
    affectedCount: affectedCountFor(stepId),
  }));
}
